import styled from 'styled-components';

import { purpurFocus } from '@telialt/common-theme/src/mixins';
import { getPurpurSpacing } from '@telialt/common-theme/src/purpurSelectors';

export const FlexContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: ${getPurpurSpacing('300')};
    padding: 0;
    gap: ${getPurpurSpacing('200')};
    line-height: 1;
`;

export const EnergyClassButton = styled.button`
    ${purpurFocus(getPurpurSpacing('50'))};
`;
